// Centralized site content for Ocean Oasis
export const BRAND = {
  name: "Ocean Oasis",
  tagline: "Connecting Somalia to the World",
  address: {
    line1: "Sundus Plaza",
    line2: "Bondhere District",
    city: "Mogadishu",
    country: "Somalia",
  },
  contact: {
    phone: "+252 610 424 241",
    email: "info@oceanoasis.llc",
    domain: "oceanoasis.llc",
    hours: "Every day · 7:00 AM – 10:00 PM",
    hoursLogistics: "Office · Sat – Thu · 8:00 AM – 9:00 PM",
    hoursLogisticsFri: "Friday · 2:00 PM – 9:00 PM",
    hoursRetail: "Every day · 7:00 AM – 10:00 PM",
  },
  social: {
    instagram: "#",
    facebook: "#",
    linkedin: "#",
    twitter: "#",
    youtube: "#",
  },
};

export const LOGOS = {
  brand:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/jjje549r_Common_Logo-removebg-preview-removebg-preview.png",
  brandWhite:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/ti93rjwl_ocean_oasis_white_transparent_logo.png",
  logistics:
    "https://customer-assets.emergentagent.com/job_62aea458-7e9f-47dd-b809-61f35deb2048/artifacts/uuz57szr_AO%20-%20Logistics%20Logo.png",
  supermarket:
    "https://customer-assets.emergentagent.com/job_62aea458-7e9f-47dd-b809-61f35deb2048/artifacts/6fi0vvoe_OA%20-%20Supermarket.jpeg",
  coffee:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/p75u2soi_WhatsApp_Image_2026-05-16_at_3.32.27_PM-removebg-preview.png",
};

export const IMAGES = {
  heroSkyline:
    "https://images.unsplash.com/photo-1763454310351-abd6b81167bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  logisticsHero:
    "https://images.unsplash.com/photo-1699588999949-e25959a59550?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  logisticsWarehouse:
    "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  // Supermarket — premium indoor supermarket scenes (custom-curated)
  supermarketFresh:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/mcem2bsp_ChatGPT%20Image%20May%2016%2C%202026%2C%2001_58_43%20PM%20%286%29.png",
  // Tall portrait hero used on the Supermarket section page (right side)
  supermarketHeroPortrait:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/h572tynw_Ocean%20Oasis%20Supermarket%20Indoor%20Hero%20Image%20-%20Supermarket%20Section%20Page%20.png",
  supermarketAisle:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/mcem2bsp_ChatGPT%20Image%20May%2016%2C%202026%2C%2001_58_43%20PM%20%286%29.png",
  supermarketCouple:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/7locbr5e_ChatGPT%20Image%20May%2016%2C%202026%2C%2001_58_43%20PM%20%285%29.png",
  // Coffee — warm bohemian café scene (also used as Relaxation Lounge)
  coffeeInterior:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/m8hoa787_ChatGPT%20Image%20May%2016%2C%202026%2C%2002_02_47%20PM%20%281%29.png",
  coffeeDrink:
    "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?fm=jpg&q=85&w=1800&auto=format&fit=crop",
  // Generic accents (no people)
  tropical:
    "https://images.unsplash.com/photo-1672841828271-54340a6fbcd3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  truck:
    "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  airfreight:
    "https://images.unsplash.com/photo-1542296332-2e4473faf563?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  produce:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/ohomkw4o_Homepage%20Photo%2C%20for%20Supermarket.png",
  beverages:
    "https://images.unsplash.com/photo-1625772299848-391b6a87d7b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  household:
    "https://customer-assets.emergentagent.com/job_ocean-hub-mogadishu/artifacts/6m47op8b_ChatGPT%20Image%20May%2016%2C%202026%2C%2001_58_42%20PM%20%284%29.png",
  espresso:
    "https://images.unsplash.com/photo-1497935586351-b67a49e012bf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  pastries:
    "https://images.unsplash.com/photo-1509440159596-0249088772ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  // Meeting space — East African / Muslim business
  meetingSpace:
    "https://plus.unsplash.com/premium_photo-1683140707316-42df87760f3f?fm=jpg&q=85&w=1600&auto=format&fit=crop",
  // East African business
  business:
    "https://plus.unsplash.com/premium_photo-1664300792003-9f5b18f6c63a?fm=jpg&q=85&w=1600&auto=format&fit=crop",
};

export const DIVISIONS = [
  {
    slug: "logistics",
    name: "Ocean Oasis Logistics",
    short: "Logistics",
    label: "Division 01",
    color: "#0a3d7a",
    tagline: "From Land to Sea to Sky.",
    blurb:
      "Integrated multi-modal cargo, customs, warehousing and distribution — engineered for global trade out of Mogadishu.",
    image: IMAGES.logisticsHero,
    logo: LOGOS.logistics,
    hours: "Office · Sat – Thu · 8:00 AM – 9:00 PM",
    hoursAlt: "Friday · 2:00 PM – 9:00 PM",
    href: "/logistics",
  },
  {
    slug: "supermarket",
    name: "Ocean Oasis Supermarket",
    short: "Supermarket",
    label: "Division 02",
    color: "#0a3d7a",
    tagline: "Premium quality. Daily abundance.",
    blurb:
      "A curated marketplace of imported and locally-sourced groceries, fresh produce and home essentials — held to one standard: world-class.",
    image: IMAGES.supermarketFresh,
    logo: LOGOS.supermarket,
    hours: "Every day · 7:00 AM – 10:00 PM",
    hoursAlt: null,
    href: "/supermarket",
  },
  {
    slug: "coffee",
    name: "Ocean Oasis Coffee",
    short: "Coffee",
    label: "Division 03",
    color: "#0a3d7a",
    tagline: "Your oasis of relaxation.",
    blurb:
      "Specialty coffee, refreshments and refined snacks served in a warm meeting space designed for conversation, focus and stillness.",
    image: IMAGES.coffeeInterior,
    logo: LOGOS.coffee,
    hours: "Every day · 7:00 AM – 10:00 PM",
    hoursAlt: null,
    href: "/coffee",
  },
];

export const LOGISTICS_SERVICES = [
  {
    title: "Ocean Freight",
    desc: "FCL & LCL container shipping, project cargo, and specialized commercial shipments connecting Somalia with key global trade routes.",
  },
  {
    title: "Air Freight",
    desc: "Fast, secure air transport for urgent, medical, humanitarian and time-sensitive cargo worldwide.",
  },
  {
    title: "Land Transportation",
    desc: "Trucking, inland transfer and regional delivery connecting ports, airports, warehouses and last-mile destinations.",
  },
  {
    title: "Customs Clearance",
    desc: "End-to-end documentation, regulatory compliance and import/export coordination handled by local experts.",
  },
  {
    title: "Warehousing & Storage",
    desc: "Short and long-term storage, inventory management and cargo consolidation for commercial and humanitarian operations.",
  },
  {
    title: "Distribution",
    desc: "Reliable last-mile delivery for retailers, institutions and infrastructure projects across Somalia and the Horn of Africa.",
  },
  {
    title: "Packing & Handling",
    desc: "Professional packing for fragile goods, industrial equipment and specialized freight — secure in transit, intact on arrival.",
  },
  {
    title: "Trilateral Solutions",
    desc: "Cross-border, multi-mode cargo movement coordinated between countries for regional and global trade.",
  },
];

export const LOGISTICS_VALUES = [
  "Reliability",
  "Integrity",
  "Transparency",
  "Operational Excellence",
  "Customer Commitment",
  "Global Connectivity",
  "Sustainable Growth",
  "Safety & Security",
];

export const SUPERMARKET_CATEGORIES = [
  {
    name: "Fresh Produce",
    desc: "Daily-sourced fruit, vegetables, herbs and greens — selected for ripeness, origin and integrity.",
    image: IMAGES.produce,
  },
  {
    name: "Groceries & Pantry",
    desc: "Rice, oils, grains, pasta, spices and dry goods from trusted local and international suppliers.",
    image: IMAGES.supermarketAisle,
  },
  {
    name: "Beverages",
    desc: "Bottled waters, juices, sodas, teas and coffees — curated across global and regional brands.",
    image: IMAGES.beverages,
  },
  {
    name: "Household Essentials",
    desc: "Cleaning, laundry, paper, kitchen and storage — premium-grade products for the modern home.",
    image: IMAGES.household,
  },
  {
    name: "Personal Care",
    desc: "Bath, skin, hair and wellness essentials chosen for quality formulation and gentle results.",
    image: IMAGES.supermarketCouple,
  },
  {
    name: "Imported Specialty",
    desc: "Hand-picked imported goods, gourmet foods and international staples flown and shipped to Mogadishu.",
    image: IMAGES.tropical,
  },
];

export const COFFEE_MENU = [
  {
    name: "Signature Espresso",
    desc: "Single & double shots pulled from a rotating selection of East African specialty beans.",
    image: IMAGES.espresso,
  },
  {
    name: "Pour Over & Filter",
    desc: "Slow-brewed origin-driven coffees — clean, bright and built to be sipped.",
    image: IMAGES.coffeeDrink,
  },
  {
    name: "Refreshments",
    desc: "Iced lattes, fresh juices, infusions, premium teas and seasonal cold brews.",
    image: IMAGES.beverages,
  },
  {
    name: "Snacks & Pastries",
    desc: "House pastries, breakfast plates and light bites prepared fresh throughout the day.",
    image: IMAGES.pastries,
  },
  {
    name: "Meeting Space",
    desc: "A quiet, well-designed room reserved for small meetings, work sessions and conversations.",
    image: IMAGES.meetingSpace,
  },
  {
    name: "Relaxation Lounge",
    desc: "A comfortable corner of the oasis — soft seating, calm music and unhurried service.",
    image: IMAGES.coffeeInterior,
  },
];

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Logistics", href: "/logistics" },
  { label: "Supermarket", href: "/supermarket" },
  { label: "Coffee", href: "/coffee" },
  { label: "About", href: "/about" },
  { label: "Contact", href: "/contact" },
];
